import { UserControlContext, UserControlSettings } from '@/contexts/user-control/helpers';
import { useContext } from 'react';

const useUserControl = () => useContext<UserControlSettings>(UserControlContext);

export default useUserControl;
